import {
  LOB_OPTIONS_ALL,
  DEPT_OPTIONS_BASE,
  AA_DEPT_MAP,
} from "../CreateNew/CreateNewForm/Clients/ClientFields";
import { getUserData } from "../../utils/authnicate";

export { LOB_OPTIONS_ALL, DEPT_OPTIONS_BASE, AA_DEPT_MAP };

export const DEFAULT_MASTER_ADMIN_EMAIL = "kumar.suman@acrossassist.com"; // TODO: dont remove , its is for client Prod env
// export const DEFAULT_MASTER_ADMIN_EMAIL = "pradip.mourya@acrossassist.com"; // TODO: dont remove , Its is only for testing

export const SPOC_ROLE_OPTIONS_DEFAULT = [
  { value: "", label: "Select Role" },
  { value: "SPOC", label: "SPOC" },
];

export const SPOC_ROLE_OPTIONS_MASTER = [
  { value: "", label: "Select Role" },
  { value: "SPOC", label: "SPOC" },
  { value: "Finance", label: "Finance" },
  { value: "Admin", label: "Admin" },
];

export const isMasterAdminUser = (userEmail) => {
  let email = userEmail;
  if (!email) {
    const user = getUserData();
    email =
      user?.email ||
      sessionStorage.getItem("otpEmail") ||
      sessionStorage.getItem("email") ||
      "";
  }
  const normalized = String(email || "")
    .trim()
    .toLowerCase();

  // Master admin check for kumar.suman@acrossassist.com
  return normalized === DEFAULT_MASTER_ADMIN_EMAIL.toLowerCase();
};

export const getSpocRoleOptions = (userEmail) => {
  if (isMasterAdminUser(userEmail)) {
    return SPOC_ROLE_OPTIONS_MASTER;
  }
  return SPOC_ROLE_OPTIONS_DEFAULT;
};

export const getSpocLobOptions = () => LOB_OPTIONS_ALL;

export const getSpocDeptOptions = (lobType) => {
  if (!lobType) return DEPT_OPTIONS_BASE;

  const seen = new Set();
  const options = [...DEPT_OPTIONS_BASE];

  Object.values(AA_DEPT_MAP).forEach((categoryMap) => {
    (categoryMap[lobType] || []).forEach((opt) => {
      if (opt.value && !seen.has(opt.value)) {
        seen.add(opt.value);
        options.push(opt);
      }
    });
  });

  return options;
};

export const SPOC_FIELDS = [
  {
    name: "employeeName",
    label: "Employee Name",
    type: "text",
    placeholder: "Enter full name",
    required: true,
  },
  {
    name: "email",
    label: "Email ID",
    type: "email",
    placeholder: "Enter email address",
    required: true,
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Enter password",
    required: true,
    hideOnView: true,
    hideOnEdit: true,
  },
  {
    name: "role",
    label: "Role",
    type: "select",
    placeholder: "Select Role",
    required: true,
    dynamicRole: true,
    options: SPOC_ROLE_OPTIONS_DEFAULT,
  },
  {
    name: "lob",
    label: "Entity LOB Type",
    type: "select",
    placeholder: "Select entity LOB type",
    required: true,
    dynamicLob: true,
    editableOnEdit: true,
    options: LOB_OPTIONS_ALL,
  },
  {
    name: "departments",
    label: "AA - Department Function",
    type: "multiselect",
    placeholder: "Select departments",
    required: true,
    dynamicDept: true,
    editableOnEdit: true,
  },
];

export const SPOC_EMPTY_FORM = {
  employeeName: "",
  email: "",
  password: "",
  mobileNumber: "",
  lob: "",
  departments: [], // array of selected department values
  role: "",
};

export const SPOC_COLUMNS = [
  // { key: "employeeId", label: "Employee ID" },
  { key: "employeeName", label: "Employee Name" },
  { key: "email", label: "Email ID" },
  { key: "lob", label: "LOB Type" },
  { key: "departments", label: "AA Department" },
  { key: "role", label: "Role" },
];
